import React from 'react';

import { Chip, Stack } from '@mui/material';
import {
  GridToolbarContainer,
  GridToolbarFilterButton,
  gridColumnLookupSelector,
  gridFilterModelSelector,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid-pro';

import { PROPERTY_NAME_FIELD, describeCountryFilter } from './utils';

export default function ReportToolbar() {
  const apiRef = useGridApiContext();
  const filterModel = useGridSelector(apiRef, gridFilterModelSelector);
  const columnLookup = useGridSelector(apiRef, gridColumnLookupSelector);

  const activeItems = filterModel.items.filter((item) =>
    item.field === PROPERTY_NAME_FIELD
      ? typeof item.value === 'string' && item.value.trim()
      : Array.isArray(item.value) && item.value.length > 0,
  );

  return (
    <GridToolbarContainer>
      <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" useFlexGap>
        <GridToolbarFilterButton />
        {activeItems.map((item) => (
          <Chip
            key={item.id}
            size="small"
            variant="outlined"
            label={
              item.field === PROPERTY_NAME_FIELD
                ? `${columnLookup[item.field]?.headerName ?? item.field} contains "${item.value.trim()}"`
                : describeCountryFilter(columnLookup[item.field]?.headerName ?? item.field, item.value)
            }
            onClick={() => apiRef.current.showFilterPanel(item.field)}
            onDelete={() => apiRef.current.deleteFilterItem(item)}
          />
        ))}
      </Stack>
    </GridToolbarContainer>
  );
}
